export interface User {
    id: string;
    isGreetingShown: boolean;
    balance: number;
    lastSeenNewsAt: string | null;
}

type ApiUser = {
    id: string;
    isGreetingShown: boolean;
    balance: number;
    lastSeenNewsAt?: string | null;
};

function toUser(apiUser: ApiUser): User {
    return {
        id: apiUser.id,
        isGreetingShown: apiUser.isGreetingShown,
        balance: apiUser.balance,
        lastSeenNewsAt: apiUser.lastSeenNewsAt ?? null,
    };
}

export type EnsureUserPayload = {
    id: string;
    email: string;
    givenName?: string | null;
    familyName?: string | null;
    isGreetingShown?: boolean;
};

export type EnsuredUser = {
    user: User;
    created: boolean;
};

export const userApi = {
    getUser: async (id: string): Promise<User | null> => {
        const response = await fetch(`/api/users?id=${id}`);
        // 404 — ожидаемое поведение для новых пользователей (ещё не в БД). Fallback: ensureUser.
        if (response.status === 404) return null;
        if (!response.ok) {
            throw new Error("Failed to fetch user data");
        }
        return toUser((await response.json()) as ApiUser);
    },
    ensureUser: async (payload: EnsureUserPayload): Promise<EnsuredUser> => {
        const response = await fetch("/api/users", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error("Failed to ensure user");
        }
        const body = (await response.json()) as ApiUser & { created?: unknown };
        return {
            user: toUser(body),
            created: body.created === true,
        };
    },
    updateUser: async (data: Partial<User> & { id: string, email: string, givenName?: string, familyName?: string, isGreetingShown?: boolean }): Promise<void> => {
        const response = await fetch("/api/users", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error("Failed to update user data");
        }
    }
};
